import { useEffect, useRef, useState } from 'react';

const INTERACTIVE = 'a, button, [data-magnetic], .faq-question, select, label';
const PLAYABLE = '.video-thumbnail, .ai-video-thumbnail, .vw-thumb, .vw-featured';

export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [enabled] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(hover: hover) and (pointer: fine)').matches
  );

  useEffect(() => {
    if (!enabled) return;
    document.body.classList.add('fx-cursor');
    const dot = dotRef.current;
    const ring = ringRef.current;
    let mx = -100, my = -100;
    let rx = -100, ry = -100;
    let raf;
    let magneticEl = null;

    const loop = () => {
      rx += (mx - rx) * 0.18;
      ry += (my - ry) * 0.18;
      dot.style.transform = `translate3d(${mx}px, ${my}px, 0) translate(-50%, -50%)`;
      ring.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onMove = (e) => {
      mx = e.clientX;
      my = e.clientY;
      dot.style.opacity = '1';
      ring.style.opacity = '1';
      const m = e.target instanceof Element ? e.target.closest('[data-magnetic]') : null;
      if (magneticEl && magneticEl !== m) {
        magneticEl.style.transform = '';
        magneticEl = null;
      }
      if (m) {
        magneticEl = m;
        const r = m.getBoundingClientRect();
        const dx = e.clientX - (r.left + r.width / 2);
        const dy = e.clientY - (r.top + r.height / 2);
        m.style.transform = `translate(${dx * 0.22}px, ${dy * 0.22}px)`;
      }
    };
    const onOver = (e) => {
      if (!(e.target instanceof Element)) return;
      const isPlay = !!e.target.closest(PLAYABLE);
      ring.classList.toggle('is-play', isPlay);
      ring.classList.toggle('is-hover', !isPlay && !!e.target.closest(INTERACTIVE));
    };
    const onLeave = () => {
      dot.style.opacity = '0';
      ring.style.opacity = '0';
    };
    const onDown = () => ring.classList.add('is-down');
    const onUp = () => ring.classList.remove('is-down');

    window.addEventListener('mousemove', onMove, { passive: true });
    document.addEventListener('mouseover', onOver, { passive: true });
    document.documentElement.addEventListener('mouseleave', onLeave);
    window.addEventListener('mousedown', onDown);
    window.addEventListener('mouseup', onUp);

    return () => {
      cancelAnimationFrame(raf);
      document.body.classList.remove('fx-cursor');
      window.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseover', onOver);
      document.documentElement.removeEventListener('mouseleave', onLeave);
      window.removeEventListener('mousedown', onDown);
      window.removeEventListener('mouseup', onUp);
      if (magneticEl) magneticEl.style.transform = '';
    };
  }, [enabled]);

  if (!enabled) return null;

  return (
    <>
      <div className="fx-cursor-dot" aria-hidden="true" ref={dotRef} data-testid="custom-cursor-dot" />
      <div className="fx-cursor-ring" aria-hidden="true" ref={ringRef} data-testid="custom-cursor-ring">
        <span className="fx-cursor-label">PLAY</span>
      </div>
    </>
  );
}
